module.exports = __webpack_public_path__ + "static/logo-10f031c2b8705b8affab480a1def157f.png";